import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2024 Sarayu Urban Multi state Co-operative Credit Society. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;